import { render, staticRenderFns } from "./AuditLogs.vue?vue&type=template&id=9aaf58a0"
import script from "./AuditLogs.vue?vue&type=script&lang=js"
export * from "./AuditLogs.vue?vue&type=script&lang=js"
import style0 from "./AuditLogs.vue?vue&type=style&index=0&id=9aaf58a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports